import React from 'react';


const TypeView = ({ type }) => {
  const typeList = {
    audio: 'Весь каталог + аудиокниги',
    standard: 'Ограниченный каталог',
    pro: 'Весь каталог + аудиокниги',
    rent: 'Аренда',
  };
  return (
    <div>{typeList[type]}</div>
  );
};

export default TypeView;
